import React, { useState, useContext, useRef } from "react";
import DataTable from "react-data-table-component";
import { IoCloudDownloadOutline } from "react-icons/io5";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import exportFromJSON from "export-from-json";
import dayjs from "dayjs";
import { Modal } from "react-bootstrap";
import { FiPrinter } from "react-icons/fi";
// import ReactToPrint from "react-to-print";
import { useReactToPrint } from 'react-to-print';

//internal import
import PageHeader from "../../components/common/PageHeader";
import ModalLoading from "../../components/Loading/ModalLoading";
import useAsync from "../../hooks/useAsync";
import DropDownService from "../../services/DropDownService";
import ReportService from "../../services/ReportService";
import { allContext } from "../../context/AllContext";
import TableLoading from "../../components/Loading/TableLoading";

function EmployeeReport() {

    const printRef = useRef();
    const [employeeId, setEmployeeId] = useState("");
    const [departmentId, setDepartmentId] = useState("");
    const [isViewModal, setIsViewModal] = useState(false);
    const [employeeModalData, setEmployeeModalData] = useState([]);
    const [modalDataType, setModalDataType] = useState("ticket");
    const [startDate, setStartDate] = useState(dayjs().format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"));
    const { reportSearch, setReportSearch, page, setPage, limit, setLimit } = useContext(allContext);

    const { data, loading, tableLoading } = useAsync(() => ReportService.getAllEmployeeReport({ employeeId: employeeId, departmentId: departmentId, designationId: "", fromDate: startDate, toDate: endDate, page: page, limit: limit }));
    const { data: employeeDropdown } = useAsync(() => DropDownService.employeeDropDown());
    const { data: departmentDropDown } = useAsync(() => DropDownService.getDepartmentDropDown());

    let columnT = ""

    columnT = [
        {
            name: "EMP ID",
            selector: (row) => row.employeeCode,
            sortable: true,
            cell: (row) => <b>{row.employeeCode}</b>
        },
        {
            name: "NAME",
            selector: (row) => row.employeeName,
            sortable: true
        },
        {
            name: "USER NAME",
            selector: (row) => row.employeeUsername,
            sortable: true,
            cell: row => <div><span className="fw-bold ms-1">{row.employeeUsername}</span></div>,
            minWidth: "250px"
        },
        {
            name: "EMAIL",
            selector: (row) => row.emailId,
            minWidth: "250px",
            sortable: true
        },
        {
            name: "MOBILE",
            selector: (row) => row.phone,
            sortable: true
        },
        {
            name: "ROLE",
            selector: (row) => row.department?.departmentName,
            sortable: true
        },
        {
            name: "JOIN DATE",
            selector: (row) => row.joiningDate,
            sortable: true
        },
        {
            name: "STATUS",
            selector: (row) => { },
            sortable: true,
            cell: row => <span className={`badge ${row.status === "Completed" || row.status === "Active" ? 'bg-success' : "bg-warning"}`}>{row.status}</span>
        }
    ];

    const modalTicketColumnT = [
        {
            name: "SUBJECT",
            selector: (row) => row?.subject,
            sortable: true,
            wrap: true,
            cell: row => <div><span className="fw-bold ms-1">{row.subject}</span></div>,
        },
        {
            name: "CLIENT",
            selector: (row) => row?.clientName,
            sortable: true,
            cell: row => <div><span className=" ms-1">{row?.clientName}</span></div>,
        },
        {
            name: "ASSIGNED",
            selector: (row) => row?.assigneeName,
            sortable: true,
            cell: row => <div><b className=" ms-1">{row.assigneeName}</b></div>,
            minWidth: "150px"
        },
        {
            name: "STATUS",
            selector: (row) => { },
            sortable: true,
            cell: row => <span className={`badge ${row.status === "Completed" ? 'bg-success' : row.status === "Hold" ? "bg-danger" : "bg-warning"}`}>{row.status}</span>
        }
    ];

    const modalTaskColumnT = [
        {
            name: "TASK",
            selector: (row) => row?.tasks || "",
            sortable: true,
            wrap: true,
            cell: row => <div><span className="fw-bold ms-1">{row?.tasks || ""}</span></div>,
        },
        {
            name: "PROJECT",
            selector: (row) => row?.projectName,
            sortable: true,
            cell: row => <div><span className=" ms-1">{row?.projectName}</span></div>,
            minWidth: "150px"
        },
        {
            name: "Start Time",
            selector: (row) => row?.taskStartDate,
            sortable: true,
            cell: row => <div><span className=" ms-1">{row?.taskStartDate || "-"}</span></div>,
        },
        {
            name: "End Time",
            selector: (row) => row?.taskEndDate,
            sortable: true,
            cell: row => <div><span className=" ms-1">{row?.taskEndDate || "-"}</span></div>,
        },
        {
            name: "HOURS",
            selector: (row) => row?.hours,
            sortable: true,
            cell: row => <div><span className=" ms-1">{row?.hours || "-"}</span></div>,
        },
        {
            name: "Productivity",
            selector: (row) => row?.productivity,
            sortable: true,
            cell: row => <div><span className=" ms-1">{row?.productivity || "-"}</span></div>,
        },
        {
            name: "STATUS",
            selector: (row) => { },
            sortable: true,
            cell: row => <span className={`badge ${row.status === "Completed" ? 'bg-success' : row.status === "Hold" ? "bg-danger" : "bg-warning"}`}>{row.status}</span>
        }
    ];

    const handleDownloadReport = async (downloadType) => {
        try {
            const res = await ReportService.getAllEmployeeReport({ employeeId: employeeId, departmentId: departmentId, designationId: "", fromDate: startDate, toDate: endDate, page: "", limit: "" });
            if (downloadType === "pdf" && res?.success) {
                const exportData = res?.data?.map((val, index) => {
                    return [
                        val.employeeCode,
                        val.employeeName,
                        val.employeeUsername,
                        val.emailId,
                        val.phone,
                        val.department?.departmentName,
                        val.joiningDate,
                        val.status
                    ]
                });
                const head = ["EMP ID", "NAME", "USER NAME", "EMAIL", "MOBILE", "ROLE", "JOIN DATE", "STATUS"];
                const unit = "pt";
                const size = "A4"; // Use A1, A2, A3 or A4
                const orientation = "landscape"; // portrait or landscape  
                const doc = new jsPDF(orientation, unit, size);
                doc.setFontSize(15);
                const headers = [head];
                let content = {
                    startY: 50,
                    head: headers,
                    body: exportData
                };

                const header = "Employee Report";
                const footer = dayjs().format("DD-MM-YYYY hh:mm A");
                const pageSize = doc.internal.pageSize;
                const pageWidth = pageSize.width || pageSize.getWidth();
                const pageHeight = pageSize.height || pageSize.getHeight();

                doc.text(header, 40, 15);
                doc.text("CRM with Sunpro", 500, 15, { baseline: 'top' });
                doc.autoTable(content);
                doc.setFontSize(8);
                doc.text(footer, pageWidth / 1.2, pageHeight - 50, { baseline: 'bottom' });

                doc.save("employee-report" + Date.now() + ".pdf");
            }
            else if (downloadType === "csv" || downloadType === "xls") {
                const exportData = res?.data?.map((val) => {
                    return {
                        "EMP ID": val?.employeeCode,
                        "NAME": val.employeeName,
                        "USER NAME": val.employeeUsername,
                        "EMAIL": val.emailId,
                        "MOBILE": val.phone,
                        "ROLE": val.department?.departmentName,
                        "JOIN DATE": val.joiningDate,
                        "STATUS": val.status
                    }
                });
                exportFromJSON({
                    data: exportData,
                    fileName: "employee-report" + Date.now(),
                    exportType: downloadType,
                });
            }
        } catch (error) {
            console.error("error", error)
        }
    }

    const handleClearFilter = () => {
        setEmployeeId("");
        setDepartmentId("");
        setReportSearch(!reportSearch);
    }
    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    });

    const handleModalOpen = (row) => {
        setEmployeeModalData(row || []);
        setModalDataType("ticket");
        setIsViewModal(true);
    }

    const handlePageChange = (page) => {
        setPage(page);
        setReportSearch(!reportSearch);
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        setLimit(newPerPage);
        setPage(1); // reset to first page on limit change
        setReportSearch(!reportSearch)
    };


    return (
        <div className="container-xxl">
            {loading ? <ModalLoading loading={loading} /> :
                <>
                    <PageHeader headerTitle="Employee Report" renderRight={() => {
                        return <div className="col-auto d-flex w-sm-100">
                        </div>
                    }} />
                    <div className="row">
                        <div className="col-lg-12 pb-4 d-flex justify-content-start">
                            <div className=" col-lg-3 p-2">
                                <label className="form-label">Start Date</label>
                                <input
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    className="form-control"
                                    placeholder="Search Project name and category"
                                    aria-label="search"
                                    max={endDate}
                                    aria-describedby="addon-wrapping" />
                            </div>
                            <div className=" col-lg-3 p-2">
                                <label className="form-label">End Date</label>
                                <input
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    min={startDate}
                                    className="form-control"
                                    placeholder="Search Project name and category"
                                    aria-label="search"
                                    aria-describedby="addon-wrapping" />
                            </div>
                            <div className=" col-lg-3 p-2">
                                <label className="form-label">Select Employee</label>
                                <select className="form-select"
                                    value={employeeId}
                                    onChange={(e) => setEmployeeId(e.target.value)}
                                >
                                    <option value="">--- All Employee ---</option>
                                    {employeeDropdown?.data?.map((val, idx) => (
                                        <option key={idx} value={val?.value}>{val?.label}</option>
                                    ))
                                    }
                                </select>
                            </div>

                            <div className=" col-lg-3 p-2">
                                <label className="form-label">Select Role</label>
                                <select className="form-select"
                                    value={departmentId}
                                    onChange={(e) => setDepartmentId(e.target.value)}
                                >
                                    <option value="">--- All Role ---</option>
                                    {departmentDropDown?.data?.map((val, idx) => (
                                        <option key={idx} value={val?.value}>{val?.label}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-12 pb-2 d-flex justify-content-end">
                            <div className="ms-5  p-2 me-2">
                                <button className="btn btn-dark  px-4 me-2" type="submit" onClick={() => handleClearFilter()}><span className="text-white dark:text-gray-200">Reset</span></button>
                                <button className="btn btn-dark  px-4 " type="submit" onClick={() => setReportSearch(!reportSearch)}><span className="text-white dark:text-gray-200">Search</span></button>
                            </div>
                        </div>
                        <div className="col-lg-12 p-4 pt-6 mt-1 d-flex justify-content-end">
                            <button className={`btn btn-dark btn-set-task w-sm-100 m-2 ${data?.data.length === 0 && "opacity-50"}`} onClick={() => data?.data.length !== 0 && handleDownloadReport("csv")}><span className=" me-2 fs-6"><IoCloudDownloadOutline /></span> CSV </button>
                            <button className={`btn btn-dark btn-set-task w-sm-100 m-2 ${data?.data.length === 0 && "opacity-50"}`} onClick={() => data?.data.length !== 0 && handleDownloadReport("xls")}><span className=" me-2 fs-6"><IoCloudDownloadOutline /></span>EXCEL</button>
                            <button className={`btn btn-dark btn-set-task w-sm-100 m-2 ${data?.data.length === 0 && "opacity-50"}`} onClick={() => data?.data.length !== 0 && handleDownloadReport("pdf")}><span className=" me-2 fs-6"><IoCloudDownloadOutline /></span>PDF</button>
                            {/* <button onClick={() => handlePrint} className={`btn btn-dark btn-set-task w-sm-100 m-2 ${data?.data.length === 0 && "opacity-50"}`} >
                                <span className=" me-2 fs-6"><FiPrinter /></span>
                                Print
                            </button> */}
                            {/* <ReactToPrint
                                trigger={() => (
                                    <button  className="btn btn-dark btn-set-task w-sm-100 m-2">
                                        <span className=" me-2 fs-6"><FiPrinter /></span>
                                        Print
                                    </button>
                                )}

                                content={() => printRef.current}
                                documentTitle="Invoice"
                            /> */}
                        </div>
                    </div>
                    <div className="row clearfix g-3">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body" ref={printRef}>
                                    <DataTable
                                        title="Users"
                                        columns={columnT}
                                        data={data?.data}
                                        defaultSortField="title"
                                        pagination
                                        selectableRows={false}
                                        className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                        highlightOnHover={true}
                                        progressPending={tableLoading}
                                        onRowClicked={(row) => handleModalOpen(row)}
                                        progressComponent={<TableLoading row={10} col={7} width={160} height={20} />}
                                        paginationServer
                                        paginationTotalRows={100}
                                        onChangePage={handlePageChange}
                                        onChangeRowsPerPage={handlePerRowsChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
            <Modal show={isViewModal} size="xl" centered onHide={() => { setIsViewModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold w-100 text-center ">{employeeModalData?.projectName} {modalDataType === "ticket" ? "Tickets" : "Tasks"}</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className="col-lg-12 pb-2 d-flex justify-content-center gap-5">
                        <div >
                            <input
                                type="radio"
                                className="m-2 "
                                id="ticket"
                                style={{ transform: "scale(1.5)" }}
                                checked={modalDataType === "ticket" ? true : false}
                                onChange={(e) => setModalDataType(e.target.checked ? "ticket" : "task")}
                            />
                            <label className="form-label" for="ticket">Tickets</label>
                        </div>
                        <div >
                            <input
                                type="radio"
                                className="m-2"
                                id="tasks"
                                style={{ transform: "scale(1.5)" }}
                                checked={modalDataType === "task" ? true : false}
                                onChange={(e) => setModalDataType(e.target.checked ? "task" : "ticket")}
                            />
                            <label className="form-label text" for="tasks" >Tasks</label>
                        </div>
                    </div>
                    <div className="row clearfix g-3" >
                        <div className="col-md-12">
                            <div className="card ">
                                <div className="card-body" ref={printRef}>
                                    <DataTable
                                        title="Project Tickets"
                                        columns={modalDataType === "ticket" ? modalTicketColumnT : modalTaskColumnT}
                                        data={modalDataType === "ticket" ? employeeModalData?.tickets : employeeModalData?.tasks || []}
                                        defaultSortField="title"
                                        selectableRows={false}
                                        className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                        highlightOnHover={true}
                                        progressPending={loading}
                                        progressComponent={<ModalLoading loading={loading} />}
                                        fixedHeader
                                        fixedHeaderScrollHeight="440px"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}


export default EmployeeReport;